class RingConfigurator {
    constructor() {
        //STATE
        this.selections     = {};
        this.resolvedHandle = '/products/';
        this.variantId      = null;
        this.currentPrice   = null;
        this.currentTitle   = "";
        this.currentSKU     = "";
        this.metafields     = {};
        this.toastTimeout   = null;
        this.toastMessage   = null;
        this.productData    = {};
        this.selectionKeys = {};
        
        //DOM
        this.container          = document.querySelector('.main-config-container');
        this.configurator       = document.querySelector('.config-content');
        this.atcButton          = document.getElementById('config-atc');
        this.resetButton        = document.getElementById('reset-btn');
        this.imgElement         = document.getElementById('preview-image');
        this.loadingIndicator   = document.getElementById('loading-indicator');
        this.imageSpinner       = document.getElementById('image-spinner'); // add this
        this.overlay            = document.getElementById('config-overlay');
        this.priceValue         = document.querySelector('.price-final span');
        this.galleryContainer   = document.querySelector('.media-gallery');
        this.productTitle       = document.getElementById('product-title');
        this.productSKU         = document.getElementById('product-sku');
        this.atcText            = this.atcButton?.querySelector('div');
        this.atcOriginalText    = this.atcText?.textContent || 'ADD TO CART';
        this.dataContainer      = document.getElementById('product-data');
        this.engravingBtn       = document.getElementById('config-engraving');
        this.engravingWrapper   = document.getElementById('engraving');
        this.engravingInput     = document.getElementById('engraving-text');
        this.engravingApplyBtn  = this.engravingWrapper?.querySelector('.apply-btn');
        this.engravingClearBtn  = this.engravingWrapper?.querySelector('.clear-input-btn');
        this.engravingFonts     = this.engravingWrapper?.querySelectorAll('[type="radio"]');
        this.storytellingTitle  = document.getElementById('storytelling-title');
        this.cartPopup          = document.getElementById('cart-ready');
        this.stepContainers     = document.querySelectorAll('.configurator-step'); //get all steps
        this.isFetching         = false; //debounce and race condition flag
        //Config Data
        const configDataElement = document.getElementById('ring-config-data');
        if (configDataElement) {
            this.configData = JSON.parse(configDataElement.textContent);
        } else {
            this.configData = { steps: [] };
        }

        this.STORAGE_KEY = `configurator_${this.container.dataset.configHandle || 'default'}`;
        
        //debounce function
        this.debouncedFetch = (handle, delay = 200) => {
            clearTimeout(this.fetchTimeout);
            this.fetchTimeout = setTimeout(() => {
                this.isFetching = true;
                this.fetchProductByHandle(handle).finally(() => {
                    this.isFetching = false;
                });
            }, delay);
        };
    }
    
    init() {
        if (!this.container) {
            //console.warn('Container not found');
            return;
        }
    
        this.bindEvents();
        this.updateImage();
        this.restoreSelections();
        this.autoSelectSingles();
        //console.log('FULL CONFIG:', this.configData);

        const sizeStep = this.configData.steps.find(s => s.key === 'gemstone-size');
        //console.log('SIZE STEP OPTIONS:', sizeStep?.options);
        
    }

    updateConfigurator(changedStepKey = null) {
        this.showValidationMessage(null);
        this.updateResolvedHandle();
        this.saveSelections();
        this.applyRules();
        this.updateGemstoneSizeLabels();
        //this.updateGemStory();
        
        const changedStep = this.configData.steps.find(step => step.key === changedStepKey);
        const shouldFetch = changedStep ? !changedStep.excludeFromSlug : true;
    
        if (shouldFetch) {
            this.debouncedFetch(this.resolvedHandle);
        
        } else {
            //console.log('Skipped fetch for excluded step:', changedStepKey);
        }
    }

        updateLoadingUI(show) {
            if (!this.container || !this.loadingIndicator || !this.overlay) return;
        
            this.overlay.classList.toggle('visible', show);
            this.loadingIndicator.classList.toggle('visible', show);
        
            if (show) {
                this.imageSpinner?.classList.add('visible');
            } else {
                this.imageSpinner?.classList.remove('visible');
            }
        }

    //LISTENERS
    bindEvents() {
        
        window.addEventListener('load', () => {
            const scrollY = sessionStorage.getItem('scrollY');
        
            if (scrollY !== null) {
                window.scrollTo(0, parseInt(scrollY, 10));
                sessionStorage.removeItem('scrollY');
            }
        });

        //console.log("BIND EVENTS START");
        const goToCartBtn = document.getElementById('go-to-cart');
        if (goToCartBtn) {
            goToCartBtn.addEventListener('click', () => {
                window.location.href = '/cart';
            });
        }
        this.cartPopup.addEventListener('click', (e) => {
        if (e.target === this.cartPopup) {
            this.hideCartPopup();
        }
        });
        document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') {
            this.hideCartPopup();
        }
        });
        //font radios
        if (this.engravingFonts) {
            this.engravingFonts.forEach(font => {
                font.addEventListener('change', () => {
                    this.selections['font'] = font.value;
                });
            });
        }

        // Step option changes (radio + dropdown)
        this.stepContainers.forEach(step => {
            const stepKey = step.dataset.stepKey;

            // Radio buttons
            const radios = step.querySelectorAll('input[type="radio"]:not([name="font"])');
            radios.forEach(radio => {
                radio.addEventListener('click', (e) => {
                    if (radio.dataset.disabled === "true") {
                        e.preventDefault();
                    
                        this.showToastMessage(
                            'This cannot be combined with current selection',
                            'error'
                        );
                    
                        return;
                    }
                    const stepEl = radio.closest('.configurator-step');
                    stepEl?.classList.remove('is-missing');

                    const helper = stepEl?.querySelector('.missing-helper');
                    if (helper) helper.remove();
                    
                    this.selections[stepKey] = radio.dataset.handleAlias;
                    this.selectionKeys[stepKey] = radio.dataset.optionKey;
                    this.updateConfigurator(stepKey);
                });
            });

            // Dropdowns (Custom)
            const customDropdowns = step.querySelectorAll('.custom-dropdown');
            customDropdowns.forEach(dropdown => {
                const trigger = dropdown.querySelector('.dropdown-trigger');
                const menu = dropdown.querySelector('.dropdown-menu');
                const options = dropdown.querySelectorAll('.dropdown-item');
                const stepKey = dropdown.dataset.stepKey;
            
                // Toggle menu visibility
                trigger.addEventListener('click', (e) => {
                    e.stopPropagation();
                    menu.classList.toggle('is-open');
                });
            
                // Handle selection
                options.forEach(option => {
                    option.addEventListener('click', () => {
                        if (option.classList.contains('is-disabled')) {
                            this.showToastMessage(
                                'This cannot be combined with current selection',
                                'error'
                            );
                            return;
                        }
                    
                        const alias = option.dataset.handleAlias;
                        const labelText = option.querySelector('span').textContent.trim();
                    
                        
                        trigger.querySelector('.trigger-text').innerText = labelText;
                        menu.classList.remove('is-open');
                    
                        this.selections[stepKey] = alias;
                        this.selectionKeys[stepKey] = option.dataset.optionKey;
                    
                        //console.log('selectionKeys:', this.selectionKeys);
                    
                        this.updateConfigurator(stepKey);
                    });
                });
            });
        });

        this.engravingBtn.addEventListener('click', () => {
            this.engravingWrapper.classList.toggle('content-hidden');

            if (this.engravingWrapper.classList.contains('content-hidden')) {
                this.engravingBtn.classList.remove('is-active-btn');
            } else {
                this.engravingBtn.classList.add('is-active-btn');
            }
        });

        if (this.engravingClearBtn) {
            this.engravingClearBtn.addEventListener('click', () => {
                this.engravingInput.value = "";
                this.engravingApplyBtn.click();
            });
        }


        // Close all menus if clicking outside
        document.addEventListener('click', (e) => {
            if (e.target.closest('.custom-dropdown')) return;
        
            document.querySelectorAll('.dropdown-menu').forEach(m => {
                m.classList.remove('is-open');
            });
        });

        // Reset button listener
        if (this.resetButton) {
            this.resetButton.addEventListener('click', () => 
            this.clearSelections()
        );
        }
        if (this.engravingWrapper && this.engravingInput) {
            this.engravingWrapper.addEventListener('click', () => {
                this.engravingInput.focus();
            });
        }

        if (this.engravingApplyBtn && this.engravingInput) {
            this.engravingApplyBtn.addEventListener('click', () => {
                const value = this.engravingInput.value.trim();
                
                this.selections['engraving'] = value;
                
                this.saveSelections();
                
                // Optional feedback
                this.showToastMessage(
                    value ? 'Engraving applied' : 'Engraving cleared',
                    'info'
                );
            });
        }
        // Add to Cart button listener
        if (this.atcButton) {
            this.atcButton.addEventListener('click', async () => {

                const validation = this.validateSelections();
                if (validation !== true) {
                    this.showValidationMessage(validation.type);
                    this.highlightMissingSteps(validation.missing);
                    return;
                }

                if (!this.variantId) {
                    //console.error("Variant not found");
                    return;
                }
                // Everything complete, we can add to cart
                this.addToCart(this.variantId);
            });
        }
    }
    
    hideCartPopup() {
        if (!this.cartPopup) return;
        document.body.style.overflow = ''
        this.cartPopup.classList.remove('is-active');

        sessionStorage.setItem('scrollY', window.scrollY);

        location.reload();
    }

    saveSelections() {
        localStorage.setItem(this.STORAGE_KEY, JSON.stringify(this.selections));
    }
    autoSelectSingles() {
        if (this.isAutoSelecting) return;

        this.isAutoSelecting = true;

        this.stepContainers.forEach(step => {
            const stepKey = step.dataset.stepKey;

            if (this.selections[stepKey]) return;

            
            const radios = Array.from(
                step.querySelectorAll('input[type="radio"]:not([name="font"])')
            );

            if (radios.length > 0) {
                const available = radios.filter(r => r.dataset.disabled !== "true");

                if (available.length === 1) {
                    const radio = available[0];

                    radio.checked = true;

                    this.selections[stepKey] = radio.dataset.handleAlias;
                    this.selectionKeys[stepKey] = radio.dataset.optionKey;

                    this.updateConfigurator(stepKey);
                    return;
                }
            }

           
            const dropdownItems = Array.from(
                step.querySelectorAll('.dropdown-item')
            );

            if (dropdownItems.length > 0) {
                const available = dropdownItems.filter(
                    item => !item.classList.contains('is-disabled')
                );

                if (available.length === 1) {
                    const item = available[0];

                    const dropdown = step.querySelector('.custom-dropdown');
                    const triggerText = dropdown?.querySelector('.trigger-text');

                    const labelText = item.querySelector('span')?.textContent.trim();

                    if (triggerText && labelText) {
                        triggerText.innerText = labelText;
                    }

                    this.selections[stepKey] = item.dataset.handleAlias;
                    this.selectionKeys[stepKey] = item.dataset.optionKey;

                    this.updateConfigurator(stepKey);
                }
            }
        });

        this.isAutoSelecting = false;
    }
    restoreSelections() {
        const saved = localStorage.getItem(this.STORAGE_KEY);
        if (!saved) return;

        this.selections = JSON.parse(saved);

        Object.entries(this.selections).forEach(([key, value]) => {
            // Find the step container by data-step-key
            const step = document.querySelector(`[data-step-key="${key}"]`);
            if (!step) return;

            const radio = step.querySelector(`input[data-handle-alias="${value}"]`);
            if (radio) {
                radio.checked = true;
                this.selectionKeys[key] = radio.dataset.optionKey;
            }

            const customDropdown = step.querySelector('.custom-dropdown');
            if (customDropdown) {
                const triggerText = customDropdown.querySelector('.trigger-text');
                const allOptions = customDropdown.querySelectorAll('.dropdown-item');

                const matchedOption = customDropdown.querySelector(`.dropdown-item[data-handle-alias="${value}"]`);

                if (matchedOption && triggerText) {
                    const labelText = matchedOption.querySelector('span').textContent.trim();
                    triggerText.innerText = labelText;

                    allOptions.forEach(opt => opt.classList.remove('is-active'));
                    matchedOption.classList.add('is-active');
                    this.selectionKeys[key] = matchedOption.dataset.optionKey;
                }
            }
        });
        

        if (this.engravingInput && this.selections['engraving']) {
            this.engravingInput.value = this.selections['engraving'];
        
            if (this.engravingWrapper) {
                this.engravingWrapper.classList.remove('content-hidden');
            }
        
            if (this.engravingBtn) {
                this.engravingBtn.classList.add('is-active-btn');
            }
        }

        this.updateResolvedHandle();
        this.applyRules();
        this.debouncedFetch(this.resolvedHandle);

        this.updateImage();
        //this.updateGemStory();
        this.autoSelectSingles();
    }

    clearSelections() {
        // Read the first step's key from config data so we know what to keep
        const firstStepKey = this.configData.steps[0]?.key;

        // Pull out the first step's current values BEFORE we wipe everything
        const preservedSelection    = firstStepKey ? this.selections[firstStepKey]    : undefined;
        const preservedSelectionKey = firstStepKey ? this.selectionKeys[firstStepKey] : undefined;

        this.selections    = preservedSelection    ? { [firstStepKey]: preservedSelection }    : {};
        this.selectionKeys = preservedSelectionKey ? { [firstStepKey]: preservedSelectionKey } : {};

        this.variantId    = null;
        this.currentPrice = null;
        this.currentTitle = "";
        this.metafields   = {};
        this.firstImage   = null;
        this.images       = [];

        if (this.engravingInput)   this.engravingInput.value = '';
        if (this.engravingWrapper) this.engravingWrapper.classList.add('content-hidden');
        if (this.engravingBtn)     this.engravingBtn.classList.remove('is-active-btn');

        clearTimeout(this.fetchTimeout);
        if (this.abortController) {
            this.abortController.abort();
            this.abortController = null;
        }

        this.saveSelections();

        // Reset UI inputs — SKIP the first step
        this.stepContainers.forEach(step => {
            if (step.dataset.stepKey === firstStepKey) return; // <-- leave it alone

            const radios = step.querySelectorAll('input[type="radio"]');
            radios.forEach(radio => { radio.checked = false; });

            const customDropdown = step.querySelector('.custom-dropdown');
            if (customDropdown) {
                const trigger     = customDropdown.querySelector('.dropdown-trigger');
                const triggerText = customDropdown.querySelector('.trigger-text');
                const defaultText = trigger?.dataset.defaultText || this.configData.translations.labels.select_an_option;

                if (triggerText) triggerText.innerText = defaultText;

                customDropdown.querySelectorAll('.dropdown-item').forEach(opt => opt.classList.remove('is-active'));

                const menu = customDropdown.querySelector('.dropdown-menu');
                if (menu) menu.classList.remove('is-open');
            }

            const dropdown = step.querySelector('select');
            if (dropdown) dropdown.selectedIndex = 0;
        });

        this.updateResolvedHandle();

        this.resetResolvedProductState();
        this.applyRules();
        this.showValidationMessage('clear');
    }

    updateResolvedHandle() {
      const base = '/products/';

      const slug = (this.configData.steps || [])
        .filter(step => !step.excludeFromSlug)
        .map(step => this.selections[step.key])
        .filter(Boolean)
        .map(v => v.toLowerCase().trim())
        .join('-');

      this.resolvedHandle = base + slug;
      //console.log("Handle Updated:", this.resolvedHandle);
    }

    renderGallery(images) {
        if (!this.galleryContainer) return;
    
        // clear previous thumbnails
        this.galleryContainer.innerHTML = '';

        if (!images || images.length < 2) return;
        
        images.slice(1).forEach(src => {
            const a = document.createElement('a');
            a.href = src;
            a.dataset.pswpWidth = 1600;
            a.dataset.pswpHeight = 1600;
            a.classList.add('gallery-item');
        
            const img = document.createElement('img');
            img.src = src;
            img.width = 100;
            img.height = 100;
        
            a.appendChild(img);
            this.galleryContainer.appendChild(a);
        });
    }

    showToastMessage(message = this.configData.translations.messages.added_to_cart, type = 'success') {
        if (!this.toastMessage) {
            this.toastMessage = document.createElement('div');
            this.toastMessage.classList.add('toast-message');
            document.body.appendChild(this.toastMessage);
        }
    
        this.toastMessage.textContent = message;
    
        this.toastMessage.classList.remove(
            'toast-success',
            'toast-error',
            'toast-info'
        );
    
        this.toastMessage.classList.add(`toast-${type}`);
        this.toastMessage.classList.add('visible');
    
        clearTimeout(this.toastTimeout);
    
        this.toastTimeout = setTimeout(() => {
            if (this.toastMessage) {
                this.toastMessage.classList.remove('visible');
            }
        }, 3000);
    }

        updateImage() {
            if (!this.imgElement) return;
        
            const previewLink = document.getElementById('preview-link');
        
            const placeholder = this.configData.defaultImage || '';
            const nextSrc = this.firstImage || placeholder;
        
            if (!nextSrc) return;
        
            const currentSrc = this.imgElement.getAttribute('src') || '';
        
            // same image → nothing
            if (currentSrc === nextSrc) {
                this.imageSpinner?.classList.remove('visible');
                return;
            }
        
            // determine if both images are REAL products
            const currentIsPlaceholder = currentSrc === placeholder;
            const nextIsPlaceholder = nextSrc === placeholder;
        
            const shouldAnimate =
                !currentIsPlaceholder &&
                !nextIsPlaceholder;
        
            if (shouldAnimate) {
                this.imgElement.classList.add('image-is-switching');
            }
        
            const preloader = new Image();
            preloader.src = nextSrc;
        
            preloader.onload = async () => {
            
                if (shouldAnimate) {
                    this.imgElement.classList.add('image-is-switching');
                }
            
                const elapsed = performance.now() - (this.loadingStartedAt || 0);
                const minimumDuration = 200;
            
                const remaining = Math.max(0, minimumDuration - elapsed);
            
                setTimeout(() => {
                
                    requestAnimationFrame(() => {
                    
                        this.imgElement.src = nextSrc;
                    
                        if (previewLink) {
                            previewLink.href = nextSrc;
                        }
                    
                        requestAnimationFrame(() => {
                            this.imgElement.classList.remove('image-is-switching');
                            this.imageSpinner?.classList.remove('visible');
                        });
                    
                    });
                
                }, remaining);
            };
        
            preloader.onerror = () => {
                this.imgElement.classList.remove('image-is-switching');
                this.imageSpinner?.classList.remove('visible');
            };
        }

    resetResolvedProductState() {
        this.variantId    = null;
        this.currentPrice = null;
        this.currentTitle = "";
        this.currentSKU   = "";
        this.metafields   = {};
        this.firstImage   = null;
        this.images       = [];
        this.productData  = {};

        if (this.dataContainer) {
            this.dataContainer.innerHTML = '';
        }

        this.updatePrice();
        this.updateImage();
        this.renderGallery([]);
        this.updateTitle();
    }

    //also updates sku
    updateTitle() {
        if (!this.productTitle) return;
        this.productTitle.textContent = this.currentTitle;

        if (!this.productSKU) return;
        this.productSKU.textContent = this.currentSKU;
    }
    
    updatePrice() {
        if (!this.priceValue) return;
        this.priceValue.textContent = this.currentPrice || '';
    }

    applyRules() {
        const exclusions = this.configData.exclusions || [];
        const selected = this.selectionKeys || {};
        const blocked = [];

        // RESET radios
        this.stepContainers.forEach(step => {
            const radios = step.querySelectorAll('input[type="radio"]');

            radios.forEach(radio => {
                radio.disabled = false;
                delete radio.dataset.disabled;
                const label = radio.closest('label');
                if (label) {
                    label.classList.remove('is-disabled');
                }
            });

            // RESET custom dropdown items
            const dropdownItems = step.querySelectorAll('.dropdown-item');
            dropdownItems.forEach(item => {
                item.classList.remove('is-disabled');
            });
        });

        // BUILD blocked list from exclusions
        exclusions.forEach(rule => {
            if (rule.type !== 'incompatibility') return;
            if (!rule.between || rule.between.length !== 2) return;

            const sideA = rule.between[0];
            const sideB = rule.between[1];

            const sideASelected =
                selected[sideA.step] &&
                sideA.options.includes(selected[sideA.step]);

            const sideBSelected =
                selected[sideB.step] &&
                sideB.options.includes(selected[sideB.step]);

            if (sideASelected) {
                sideB.options.forEach(optionKey => {
                    blocked.push({
                        step: sideB.step,
                        option: optionKey
                    });
                });
            }

            if (sideBSelected) {
                sideA.options.forEach(optionKey => {
                    blocked.push({
                        step: sideA.step,
                        option: optionKey
                    });
                });
            }
        });

        // DETECT selected options that became invalid
        const invalidSelected = [];

        blocked.forEach(target => {
            if (this.selectionKeys[target.step] === target.option) {
                invalidSelected.push(target);
            }
        });

        // CLEAR invalid selected options from state + UI
        invalidSelected.forEach(target => {
            delete this.selectionKeys[target.step];
            delete this.selections[target.step];

            const step = document.querySelector(`.configurator-step[data-step-key="${target.step}"]`);
            if (!step) return;

            // Clear radio UI
            const radio = step.querySelector(`input[type="radio"][data-option-key="${target.option}"]`);
            if (radio) {
                radio.checked = false;
            }

            // Clear custom dropdown UI
            const customDropdown = step.querySelector('.custom-dropdown');
            if (customDropdown) {
                const trigger = customDropdown.querySelector('.dropdown-trigger');
                const triggerText = customDropdown.querySelector('.trigger-text');
                const defaultText = trigger?.dataset.defaultText || this.configData.translations.labels.select_an_option;

                if (triggerText) {
                    triggerText.innerText = defaultText;
                }

                customDropdown.querySelectorAll('.dropdown-item').forEach(opt => {
                    opt.classList.remove('is-active');
                });
            }
        });

        // If anything was cleared, save + rebuild handle + rerun rules once
        if (invalidSelected.length > 0) {
            this.saveSelections();
            this.updateResolvedHandle();
            this.applyRules();
            return;
        }

        // APPLY blocked state to UI
        blocked.forEach(target => {
            const step = document.querySelector(`.configurator-step[data-step-key="${target.step}"]`);
            if (!step) return;

            // Radio input
            const radio = step.querySelector(`input[type="radio"][data-option-key="${target.option}"]`);
            if (radio) {
                radio.dataset.disabled = "true";
                radio.disabled = false;

                const label = radio.closest('label');
                if (label) {
                    label.classList.add('is-disabled');
                }
            }

            // Custom dropdown item
            const dropdownItem = step.querySelector(`.dropdown-item[data-option-key="${target.option}"]`);
            if (dropdownItem) {
                dropdownItem.classList.add('is-disabled');
            }
        });

        //console.log('RULES selectedKeys:', selected);
        //console.log('RULES blocked:', blocked);
        this.autoSelectSingles();
    }

    validateSelections() {
        const excludedKeys = ['ring-size'];
    
        const requiredKeys = this.configData.steps
            .map(step => step.key)
            .filter(key => !excludedKeys.includes(key));
    
        const missing = requiredKeys.filter(key => !this.selections[key]);
    
        if (missing.length > 0) {
            return { type: "config", missing };
        }
    
        if (!this.selections['ring-size']) {
            return { type: "size", missing: ['ring-size'] };
        }
    
        return true;
    }

highlightMissingSteps(missingKeys = []) {
    // clear previous highlights
    this.stepContainers.forEach(step => {
        step.classList.remove('is-missing');

        const helper = step.querySelector('.missing-helper');
        if (helper) helper.remove();
    });

    missingKeys.forEach(key => {
        const step = document.querySelector(`.configurator-step[data-step-key="${key}"]`);
        if (!step) return;

        step.classList.add('is-missing');

        // add helper text
        const helper = document.createElement('div');
        helper.classList.add('missing-helper');
        helper.textContent = 'Please select an option';

        step.appendChild(helper);
    });
}

updateGemstoneSizeLabels() {
    const cutKey = this.selectionKeys['gemstone-cut'];
    if (!cutKey) return;

    const sizeStep = this.configData.steps.find(s => s.key === 'gemstone-size');
    if (!sizeStep) return;

    const stepEl = document.querySelector('[data-step-key="gemstone-size"]');
    if (!stepEl) return;

    sizeStep.options.forEach(opt => {
        const override = opt.caratOverrides?.[cutKey];
        const newLabel = override || opt.label;

        // RADIO
        const radio = stepEl.querySelector(
            `input[data-option-key="${opt.key}"]`
        );

        if (radio) {
            const label = radio.closest('label');
            const span = label?.querySelector('span');
            if (span) span.textContent = newLabel;
        }

        // DROPDOWN
        const dropdownItem = stepEl.querySelector(
            `.dropdown-item[data-option-key="${opt.key}"] span`
        );

        if (dropdownItem) {
            dropdownItem.textContent = newLabel;
        }
    });
}

populateDetails(data) {
    const tr = this.configData.translations;
    if (!data) return;
    this.dataContainer.innerHTML = "";
    
    const map = [
        {
            section: tr.sections.general,
            label: tr.labels.fineness,
            getValue: () => data.metafields.custom.fineness
        },
        {
            section: tr.sections.general,
            label: tr.labels.gold_color,
            getValue: () => data.metafields.custom.metal
        },
        {
            section: tr.sections.general,
            label: tr.labels.weight,
            getValue: () => data.metafields.custom.weight
        },
        {
            section: tr.sections.general,
            label: tr.labels.width,
            getValue: () => data.metafields.custom.widthOfRing
        },
        {
            section: tr.sections.general,
            label: tr.labels.model,
            getValue: () => data.metafields.custom.model
        },
        
        {
            section: tr.sections.central_stone,
            label: tr.labels.gemstone,
            getValue: () => data.metafields.custom.main_gemstone
        },
        {
            section: tr.sections.central_stone,
            label: tr.labels.diamond_color,
            getValue: () => data.metafields.custom.diamondColor
        },
        {
            section: tr.sections.central_stone,
            label: tr.labels.dimensions,
            getValue: () => data.metafields.custom.dimensions
        },
        {
            section: tr.sections.central_stone,
            label: tr.labels.weight,
            getValue: () => data.metafields.custom.gemstone_size
        },
        {
            section: tr.sections.central_stone,
            label: tr.labels.cut_shape,
            getValue: () => data.metafields.custom.cut_shape
        },
        {
            section: tr.sections.central_stone,
            label: tr.labels.quality,
            getValue: () => data.metafields.custom.diamond_clarity_grade
        },
        {
            section: tr.sections.central_stone,
            label: tr.labels.setting,
            getValue: () => data.metafields.custom.gemstone_setting
        },
        {
            section: tr.sections.side_stone,
            group: tr.groups.a,
            label: tr.labels.gemstone,
            getValue: () => data.metafields.custom.additionalGems
        },
        {
            section: tr.sections.side_stone,
            group: tr.groups.a,
            label: tr.labels.quantity,
            getValue: () => data.metafields.custom.additional_gems_quantity
        },
        {
            section: tr.sections.side_stone,
            group: tr.groups.a,
            label: tr.labels.weight,
            getValue: () => data.metafields.custom.weight_of_additional_gems_a
        },
        {
            section: tr.sections.side_stone,
            group: tr.groups.b,
            label: tr.labels.gemstone,
            getValue: () => data.metafields.custom.additional_gems_b
        },
        {
            section: tr.sections.side_stone,
            group: tr.groups.b,
            label: tr.labels.quantity,
            getValue: () => data.metafields.custom.additional_gems_quantity_b
        },
        {
            section: tr.sections.side_stone,
            group: tr.groups.b,
            label: tr.labels.weight,
            getValue: () => data.metafields.custom.weightOfAdditionalGems_B
        },
        {
            section: tr.sections.side_stone,
            group: tr.groups.c,
            label: tr.labels.gemstone,
            getValue: () => data.metafields.custom.additional_gems_c
        },
        {
            section: tr.sections.side_stone,
            group: tr.groups.c,
            label: tr.labels.quantity,
            getValue: () => data.metafields.custom.additional_gems_quantity_c
        },
        {
            section: tr.sections.side_stone,
            group: tr.groups.c,
            label: tr.labels.weight,
            getValue: () => data.metafields.custom.weightOfAdditionalGems_C
        },

        {
            section: tr.sections.side_stone,
            group: tr.groups.total,
            label: tr.labels.quantity,
            getValue: () =>
                (Number(data.metafields.custom.additional_gems_quantity_b) || 0) +
                (Number(data.metafields.custom.additional_gems_quantity_c) || 0) +
                (Number(data.metafields.custom.additional_gems_quantity) || 0)
        },
        {
            section: tr.sections.side_stone,
            group: tr.groups.total,
            label: tr.labels.total_weight,
            getValue: () => data.metafields.custom.weightOfAdditionalGems
        }
    ];

    const sections = {};

    map.forEach(item => {
        const value = item.getValue();

        if (!value) return;

        if (!sections[item.section]) {
            sections[item.section] = {
                rows: [],
                groups: {}
            };
        }

        const row = {
            label: item.label,
            value: value
        };

        if (item.group) {
            if (!sections[item.section].groups[item.group]) {
                sections[item.section].groups[item.group] = [];
            }

            sections[item.section].groups[item.group].push(row);
        } else {
            sections[item.section].rows.push(row);
        }
    });

    Object.entries(sections).forEach(([sectionName, sectionData]) => {
        const wrapper = document.createElement('div');
        wrapper.classList.add('product-data-wrapper');

        const title = document.createElement('h3');
        title.textContent = sectionName;
        wrapper.appendChild(title);

        const dataColumn = document.createElement('div');
        dataColumn.classList.add('data-column');

        if (sectionData.rows.length > 0) {
            const ul = document.createElement('ul');

            sectionData.rows.forEach(row => {
                const li = document.createElement('li');

                const key = document.createElement('span');
                key.classList.add('key');
                key.textContent = row.label;

                const value = document.createElement('span');
                value.classList.add('value');
                value.textContent = row.value;

                li.appendChild(key);
                li.appendChild(value);
                ul.appendChild(li);
            });

            dataColumn.appendChild(ul);
        }

        const groupEntries = Object.entries(sectionData.groups);

        const realGroups = groupEntries.filter(([groupName, groupRows]) => {
            return groupName !== tr.groups.total && groupRows.length > 0;
        });

        const totalGroup = groupEntries.find(([groupName]) => groupName === tr.groups.total);

        if (realGroups.length === 1) {
            const [, groupRows] = realGroups[0];
            const ul = document.createElement('ul');
        
            groupRows.forEach(row => {
                const li = document.createElement('li');
                const key = document.createElement('span');
                key.classList.add('key');
                key.textContent = row.label;
                const value = document.createElement('span');
                value.classList.add('value');
                value.textContent = row.value;
                li.appendChild(key);
                li.appendChild(value);
                ul.appendChild(li);
            });
        
            if (totalGroup) {
                const [, totalRows] = totalGroup;
                totalRows.forEach(row => {
                    
                    if (row.label === tr.labels.quantity) return;

                    const li = document.createElement('li');
                    const key = document.createElement('span');
                    key.classList.add('key');
                    key.textContent = row.label;
                    const value = document.createElement('span');
                    value.classList.add('value');
                    value.textContent = row.value;
                    li.appendChild(key);
                    li.appendChild(value);
                    ul.appendChild(li);
                });
            }
            dataColumn.appendChild(ul);

        } else {
            realGroups.forEach(([groupName, groupRows]) => {
                const groupTitle = document.createElement('h4');
                groupTitle.textContent = groupName;
                dataColumn.appendChild(groupTitle);

                const ul = document.createElement('ul');

                groupRows.forEach(row => {
                    const li = document.createElement('li');

                    const key = document.createElement('span');
                    key.classList.add('key');
                    key.textContent = row.label;

                    const value = document.createElement('span');
                    value.classList.add('value');
                    value.textContent = row.value;

                    li.appendChild(key);
                    li.appendChild(value);
                    ul.appendChild(li);
                });

                dataColumn.appendChild(ul);
            });

            if (totalGroup) {
                const [groupName, groupRows] = totalGroup;

                const groupTitle = document.createElement('h4');
                groupTitle.textContent = groupName;
                dataColumn.appendChild(groupTitle);

                const ul = document.createElement('ul');

                groupRows.forEach(row => {
                    const li = document.createElement('li');

                    const key = document.createElement('span');
                    key.classList.add('key');
                    key.textContent = row.label;

                    const value = document.createElement('span');
                    value.classList.add('value');
                    value.textContent = row.value;

                    li.appendChild(key);
                    li.appendChild(value);
                    ul.appendChild(li);
                });

                dataColumn.appendChild(ul);
            }
        }

        wrapper.appendChild(dataColumn);
        this.dataContainer.appendChild(wrapper);
    });
}

    showSuccessPopup() {
        if (!this.cartPopup) return;
        document.body.style.overflow = 'hidden';
        this.renderCartPopupContent();
        this.cartPopup.classList.add('is-active');
    }
    
    renderCartPopupContent() {
        const container = document.getElementById('cart-content');
        if (!container) return;

        const continueBtn = document.getElementById('continue-shopping');
            
        if (continueBtn) {
            continueBtn.addEventListener('click', () => {
                this.hideCartPopup();
            });
        }

        container.innerHTML = '';

        const topRow = document.createElement('div');
        topRow.classList.add('cart-popup-top');

        if (this.firstImage) {
            const img = document.createElement('img');
            img.src = this.firstImage;
            img.classList.add('cart-popup-image');
            topRow.appendChild(img);
        }

        const info = document.createElement('div');
        info.classList.add('cart-popup-info');

        const title = document.createElement('div');
        title.classList.add('cart-popup-title');
        title.textContent = this.currentTitle;

        const price = document.createElement('div');
        price.classList.add('cart-popup-price');
        price.textContent = this.currentPrice;

        info.appendChild(title);
        info.appendChild(price);

        topRow.appendChild(info);

        container.appendChild(topRow);

        const list = document.createElement('ul');
        list.classList.add('cart-popup-list');

        this.configData.steps.forEach(step => {
            const key = step.key;

            if (key === 'base-model') return;
            
            const selectedKey = this.selectionKeys[key];
            if (!selectedKey) return;

            const option = step.options.find(o => o.key === selectedKey);
            if (!option) return;

            const li = document.createElement('li');

            const label = document.createElement('span');
            label.classList.add('label');
            label.textContent = step.label;

            const value = document.createElement('span');
            value.classList.add('value');
            value.textContent = option.label;

            li.appendChild(label);
            li.appendChild(value);

            list.appendChild(li);
        });

        // --- engraving (manual) ---
        if (this.selections['engraving']) {
            const li = document.createElement('li');

            const label = document.createElement('span');
            label.textContent = 'Engraving: ';

            const value = document.createElement('span');
            value.textContent = this.selections['engraving'];

            li.appendChild(label);
            li.appendChild(value);

            list.appendChild(li);
        }

        container.appendChild(list);
    }


    updateGemStory() {
        const container = document.getElementById('story-gemstone');
        if (!container) return;

        const gemstoneKey = this.selectionKeys['gemstone'];

        if (!gemstoneKey) {
            container.textContent = '';
            return;
        }

        const step = this.configData.steps.find(s => s.key === 'gemstone');
        if (!step) return;

        const option = step.options.find(opt => opt.key === gemstoneKey);
        if (!option || !option.description) {
            container.textContent = '';
            return;
        }

        if (container.textContent === option.description) return;
        container.style.opacity = 0;

        setTimeout(() => {
            container.textContent = option.description;
            container.style.opacity = 1;
        }, 250);
    }

    showValidationMessage(type) {
        if (!type) return;

        const messages = {
            config: {
                text: this.configData.translations.messages.config_incomplete,
                toastType: 'error'
            },
            size: {
                text: this.configData.translations.messages.size_missing,
                toastType: 'error'
            },
            clear: {
                text: this.configData.translations.messages.cleared,
                toastType: 'info'
            }
        };

        const entry = messages[type];
        if (!entry) return;

        this.showToastMessage(entry.text, entry.toastType);
    }

    async fetchProductByHandle(handle) {
        if (this.abortController) {
            this.abortController.abort();
        }

        this.abortController = new AbortController();

        try {
            this.updateLoadingUI(true);
            this.loadingStartedAt = performance.now();

            const response = await fetch(`${handle}?view=ajax-product`, {
                signal: this.abortController.signal
            });

            if (!response.ok) {
                this.resetResolvedProductState();
                console.warn(`Fetch Failed: ${response.status} ${response.statusText}`);
                return null;
            }

            const data = await response.json();

            this.variantId = data.variant_id;
            this.metafields = data.metafields || {};
            this.currentPrice = data.price;
            this.firstImage = data.images?.[0] || null;
            this.images = data.images || [];
            this.currentTitle = data.title || "";
            this.currentSKU   = data.sku || "";
            this.productData = data.metafields;

            this.updatePrice();
            this.updateImage();
            this.renderGallery(this.images);
            this.updateTitle();
            this.populateDetails(data);
            //console.log("Product Data: ", data);
            //console.log("Metafields:", this.metafields);

            return this.variantId;

        } catch (error) {
            if (error.name === 'AbortError') {
            } else {
                this.resetResolvedProductState();
                console.error(error);
            }
            return null;
        } finally {
            this.updateLoadingUI(false);
        }
    }

    async addToCart(variantId) {
        try {
            if (this.atcButton) {
                this.atcButton.disabled = true;
                this.atcButton.classList.add('is-loading');
            }

            if (this.atcText) {
                this.atcText.textContent = 'Adding...';
            }

            const size = (this.selections['ring-size'] || '').replace('size-', '');

            const body = {
                id: variantId,
                quantity: 1,
                properties: {
                    "Engraving": this.selections['engraving'] || '',
                    "Engraving Font": this.selections['font'] || '',
                    "Size": size
                }
            };

            const res = await fetch('/cart/add.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(body)
            });

            if (!res.ok) {
                throw new Error(`Add to cart failed: ${res.status}`);
            }

            const data = await res.json();
            //console.log('Added to cart:', data);

            this.showToastMessage(this.configData.translations.messages.added_to_cart, 'success');
            this.showSuccessPopup();

        } catch (error) {
            console.error(error);
        } finally {
            if (this.atcButton) {
                this.atcButton.disabled = false;
                this.atcButton.classList.remove('is-loading');
            }

            if (this.atcText) {
                this.atcText.textContent = this.atcOriginalText;
            }
        }
    }
}
